import { useCallback } from "react";

import { ReploError } from "schemas/errors";

import {
  useIsIframeLoaded,
  useModifiersContext,
} from "../store/ModifiersStoreContext";

class IframeMessagingError extends ReploError {}

export function useIframeMessaging() {
  const { store } = useModifiersContext();
  const isIframeLoaded = useIsIframeLoaded();

  const sendMessage = useCallback(
    (message: Record<string, unknown>) => {
      // NOTE (Nick, 2025-12-04): Don't send messages until iframe is ready to prevent race conditions
      const currentIsLoaded = store.getState().isIframeLoaded;
      if (!currentIsLoaded) {
        return;
      }

      // NOTE (Kurt, 2025-11-24): Always read current container from store instead of closing
      // over it, so we get the latest value even when called from async contexts like setTimeout.
      const container = store.getState().iframeContainer;

      if (!container) {
        return;
      }

      const iframe = container.querySelector("iframe");
      if (!iframe?.contentWindow) {
        throw new IframeMessagingError({
          message: "Could not find iframe for message",
        });
      }

      iframe.contentWindow.postMessage(message, "*");
    },
    [store],
  );

  return { sendMessage, isIframeLoaded };
}
